import { createSlice } from '@reduxjs/toolkit';

const MAX_HISTORY = 10;

const initialState = {
  filterHistory: [],
};
const generateId = () => `id_${Math.random().toString(36).substring(2, 10)}`;

const filterHistorySlice = createSlice({
  name: 'filterHistory',
  initialState,
  reducers: {
    setFilterHistory(state, action) {
      const newData = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];

      const existingSet = new Set(
        state.filterHistory.map((item) => JSON.stringify({ ...item, id: undefined }))
      );

      // Har bir yangi elementga id qo‘shamiz va duplikatlarni tekshiramiz
      const uniqueNewData = newData
        .map((item) => {
          const itemWithoutId = { ...item }; // clone before adding id
          const comparable = JSON.stringify(itemWithoutId);
          return {
            item,
            comparable,
          };
        })
        .filter(({ comparable }) => !existingSet.has(comparable))
        .map(({ item }) => ({
          ...item,
          id: generateId(),
        }));

      const combined = [...uniqueNewData, ...state.filterHistory];

      state.filterHistory = combined.slice(0, MAX_HISTORY);
    },

    clearFilterHistory(state) {
      state.filterHistory = initialState.filterHistory;
    },
  },
});

export const { setFilterHistory, clearFilterHistory } = filterHistorySlice.actions;
export default filterHistorySlice.reducer;
